<template>
  <v-star
    ref="employee"
    :config="{
      x: employee.currentCoord[0],
      y: employee.currentCoord[1],
      numPoints: 5,
      innerRadius: 6,
      outerRadius: 3,
      fill: EMPLOYEE_ACTIVITY_COLOR[activityName]
        || EMPLOYEE_ACTIVITY_COLOR.DEFAULT,
      listening: false,
    }"
  />
</template>

<script>
import { EMPLOYEE_ACTIVITY_COLOR } from '@/constants';

export default {
  name: 'PlaygroundEmployee',
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      EMPLOYEE_ACTIVITY_COLOR,
    };
  },
  computed: {
    activityName() {
      return this.employee.activity?.constructor?.name;
    },
  },
  mounted() {
    this.employee.setKonvaNode(this.$refs.employee.getNode());
  },
};
</script>
